import React from "react";

import { RouteObject } from "react-router";

import { pagesForRouter as pages } from "../utils/routrer-utils";
import WelcomePage from "../pages/welcome";
import FilesPage from "../pages/files";
import SettingsPage from "../pages/settings";
import HelpPage from "../pages/help";

import LoginPage from "../pages/login";
import CreateVideoPage from "../pages/create-video";
import ContactsPage from "../pages/contacts";
import VideoPage from "../pages/video";
import NotFoundPage from "../pages/not-found";

import { OldProtectedRoute } from "./ProtectedRoute";

import { ThemeWrapper } from "./ThemeWrapper";

export const routes: RouteObject[] = [
  {
    element: <ThemeWrapper />,
    children: [
      {
        path: pages.LOGIN,
        element: <LoginPage />,
      },
      {
        // index: true,
        path: pages.HOME,
        element: (
          <OldProtectedRoute>
            <WelcomePage />
          </OldProtectedRoute>
        ),
      },
      {
        path: pages.SETTINGS,
        element: (
          <OldProtectedRoute>
            <SettingsPage />
          </OldProtectedRoute>
        ),
      },
      {
        path: pages.MAKING,
        element: (
          <OldProtectedRoute>
            <CreateVideoPage />
          </OldProtectedRoute>
        ),
      },
      {
        path: pages.CONTRACTS,
        element: (
          <OldProtectedRoute>
            <ContactsPage />
          </OldProtectedRoute>
        ),
      },
      {
        path: pages.VIDEOS,
        children: [
          {
            index: true,
            element: (
              <OldProtectedRoute>
                <VideoPage />
              </OldProtectedRoute>
            ),
          },
          {
            path: `${pages.VIDEOS}/:package_id`,
            element: (
              <OldProtectedRoute>
                <VideoPage />
              </OldProtectedRoute>
            ),
          },
        ],
      },
      {
        path: `${pages.FILES}/:package_id`,
        element: (
          <OldProtectedRoute>
            <FilesPage />
          </OldProtectedRoute>
        ),
      },
      {
        path: pages.HELP,
        element: (
          <OldProtectedRoute>
            <HelpPage />
          </OldProtectedRoute>
        ),
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];
